/**
 * The Daily caps screen's URL view state and sort columns (DNKADM-0430 P1-F).
 *
 * URL params on `/membership-credits/daily-caps` (all optional; a default is never
 * written):
 * - `q`: search on the "Applies to" label.
 * - `sort` + `dir`: the column sort. The default is today's fixed order: Applies to
 *   ascending, which is the evaluation precedence (most specific scope first,
 *   `PLAN_BUCKET > PLAN > BUCKET > ALL`). Caps with the same scope then order by their
 *   label, so the order is deterministic.
 */
import type { DailyCap } from '@/api/dailyCaps';
import type { SortState, SortValue } from '@/components/list/listSort';

export const DAILY_CAPS_URL_DEFAULTS = { q: '', sort: '', dir: '' };

export type DailyCapSortKey = 'appliesTo' | 'cap';
export const DAILY_CAP_SORT_KEYS: readonly DailyCapSortKey[] = ['appliesTo', 'cap'];
export const DAILY_CAP_DEFAULT_SORT: SortState<DailyCapSortKey> = { key: 'appliesTo', dir: 'asc' };

/** Most-specific first, so the list reads as the evaluation precedence. */
export const SCOPE_ORDER: Record<DailyCap['scope'], number> = {
  PLAN_BUCKET: 0,
  PLAN: 1,
  BUCKET: 2,
  ALL: 3,
};

/**
 * What a cap sorts by in each column: Applies to by scope precedence (the screen breaks
 * ties on the label), Cap by its hours.
 */
export function dailyCapSortValue(cap: DailyCap, key: DailyCapSortKey): SortValue {
  switch (key) {
    case 'appliesTo':
      return SCOPE_ORDER[cap.scope];
    case 'cap':
      return cap.capHours;
  }
}
